import React from 'react';
import ContactTwo from '../../components/Contact/ContactTwo';
import Breadcrumb from '../../components/Breadcrumb';
import CtaSection from '../home/CtaSection';

const ContactMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="İletişim" />

      <ContactTwo itemClass="contact__area contact__plr-2 mt-40 mb-100 p-relative fix" />

      <CtaSection />
    </main>
  );
};

export default ContactMain;
